<template>
    <div class="container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />


        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end" v-if="is_admin">
        <v-btn 
        v-if="!is_admin"
         color="brand onBrand--text"
        dark
        small
        style="margin-top:-15px; margin-right:-0.5em; border-radius:8px;"
        @click="videoDialog = true"
        >
        <v-icon left>mdi-youtube</v-icon>
        Watch Tutorial
        </v-btn>
        </div>
        <v-row justify="center">
            <v-col sm="4" md="4" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
                    item-value="id" label="Select Academic Year" outlined @change="getDivisionData(status)" />
            </v-col>
            <v-col sm="4" md="4" cols="12">
                <v-icon color="error">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                    item-text="name" item-value="id" label="Select Status" @change="getDivisionData(status)" outlined
                    persistent-hint hint="Select Status (shows students of selected status)" />
            </v-col>
        </v-row>
        <v-row v-if="status">
            <v-col>
                <v-card>
                    <!-- {{ divisiondata }} -->
                    <v-card-title>
                        Class List
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line
                            hide-details></v-text-field>
                    </v-card-title>
                    <div id="my-table-id">
                        <v-data-table :headers="headers" :items="divisiondata" :search="search">
                            <template v-slot:[`item.action`]="{ item }">
                                <v-btn title="Add" class="ma-2" tile small @click="editItem(item)"><v-icon
                                        color="primary">mdi-plus-circle-outline</v-icon> </v-btn>

                                <v-btn title="Edit" class="ma-2" tile small @click="editattendance(item)">
                                    <v-icon color="success">mdi-pencil</v-icon>
                                </v-btn>

                                <!-- <v-btn title="Export" class="ma-2" tile small @click="exportattendace(item)"><v-icon
                                    color="warning">mdi-export</v-icon> </v-btn> -->
                                <v-btn class="ma-2" rounded color="success" outlined
                                    @click="fnExcelReport('my-table-id', 'StudentAttendanceReport')"
                                    :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                                <v-btn title="Re-Arrange Day Number" class="ma-2" tile small :loading="loader_rearrange"
                                    @click="rearrangedayno(item)"><v-icon
                                        color="warning">mdi-account-convert-outline</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>
                </v-card>
            </v-col>
        </v-row>

    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Student Attendance Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/9FroDy4oMWM?si=FJ_hzdW0TdEUcboc"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        headers: [
            { text: "Year", value: "year" },
            { text: "Division", value: "division" },
            { text: "Number of Students", value: "numstudents" },
            { text: "Total Days", value: "numdays" },
            { text: "Attendance Actions", value: "action", sortable: false },
        ],
        selected_ay: "",
        aylist: "",
        is_admin: false,
        search: "",
        divisiondata: [],
        loader_rearrange: false,
        snackbar_msg: "",
        color: "",
        videoDialog: false, 
        role:null,
        // extraBreadcrumbItems: [

        // ],
        // breadcrumbClass: "breadcrumb-style2",
        snackbar: false,
        editedItem: {
            divoff: "",
            year: "",
            division: "",
            numstudents: "",
            numdays: "",
        },
        status_list: [
            { name: "Active", id: "0" },
            { name: "Temporary Inactive", id: "1" },
            { name: "Permanent Inactive", id: "2" },
        ],
        status: null,ay_list:[],ay:"",loader:false
    }),

    mounted() {
         this.onload();
         
    },
    methods: {
        onload() {
            this.role = sessionStorage.getItem("para_role");
            if(this.role == null){
               this.role = sessionStorage.getItem("search_para_role"); 
            }
                axios
                    .post("Academics/studentAttendanceHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list),
                            (this.ay=res.data.cay),
                            (this.is_admin=res.data.is_admin)
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Year</th>
      <th>Division</th>
      <th>No. of Students</th>
      <th>Total Days</th> 
      <th>Action</th>  
    </tr>`;

  this.divisiondata.forEach((item, index) => {
    tab_text += `
    <tr>
          <td>${index + 1}</td>
          <td>${item.year}</td>
          <td>${item.division}</td>
          <td>${item.numstudents}</td>
          <td>${item.numdays}</td>
          <td></td>
        </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
        rearrangedayno(item) {
            const data = {
                divoff: item.divoff,
            };
            this.loader_rearrange = true;
            axios
                .post("/Academics/rearrangedayno", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        //   this.getDivisionData();
                        this.loader_rearrange = false;
                        this.showSnackbar("#4caf50", "Re-arranged Successfully..."); //res.data.status;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getDivisionData(status) {
            // alert("status here" +status)
            localStorage.setItem("academics_ay",this.ay)
            if(status== '' || status== null){
                 this.showSnackbar("#b71c1c", "Please Select Status...!");
                 return
            }
            const data = {
                status: status,
                ay:this.ay,
                role:this.role
            }
            axios
                .post("/Academics/getDivisionData", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.divisiondata = res.data.divisiondata;
                        // console.log(res.data.divisiondata)
                        this.aylist = res.data.aylist;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        editItem(item) {
            //  alert('stting'+this.status)
            this.editedIndex = this.divisiondata.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.$store.commit("setdivoff_id", this.editedItem.divoff);
            // this.$store.commit("setstatus_id", this.status);
            localStorage.setItem("setstatus_id", this.status);
            //this.dialog = true;
            this.getDivisionStudents();
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getDivisionStudents() {
            //  alert('calling'+this.editedItem.divoff)

            this.$router.push({ name: "mark-attendance" });
        },
        exportattendace(item) {
            this.editedIndex = this.divisiondata.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.$store.commit("setdivoff_id", this.editedItem.divoff);
            localStorage.setItem("setstatus_id", this.status);
            this.$router.push({ name: "export-attendance" });
        },
        editattendance(item) {
            this.editedIndex = this.divisiondata.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.$store.commit("setdivoff_id", this.editedItem.divoff);
            localStorage.setItem("setstatus_id", this.status);
            this.$router.push({ name: "edit-attendance" });
        },
    },
};
</script>
